<button type="button" class="disabled" [disabled]="true" [ngClass]="buttonCssClass">
    <div class="flex items-center justify-center">
        <div class="w-4 h-4 border-t-transparent border-2 border-white rounded-full animate-spin"></div>
        <p class="ml-2">{{ textDisplay | translate }}</p>
    </div>
</button>
